import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politica-devolucion',
  templateUrl: './politica-devolucion.component.html',
  styleUrls: ['./politica-devolucion.component.scss']
})
export class PoliticaDevolucionComponent implements OnInit {

  constructor() { 
    window.scrollTo(0,0);
  }

  ngOnInit(): void {
    
  }

}
